import { render } from "./TenantEditDialog.vue?vue&type=template&id=00f508a8&scoped=true"
import script from "./TenantEditDialog.vue?vue&type=script&lang=js"
export * from "./TenantEditDialog.vue?vue&type=script&lang=js"

import "./TenantEditDialog.vue?vue&type=style&index=0&id=00f508a8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00f508a8"]])

export default __exports__